<style lang="scss" scoped>
.list {
  width: 100%;
  margin-bottom: 30px;
  .iconfont {
    font-size: 30px;
    color: #173bcf;
    font-size: 32px;
    line-height: 36px;
    cursor: pointer;
  }
}
.soundLib {
  /deep/ {
    .el-dialog__body {
      padding: 10px 20px 30px;
    }
    .el-table__header-wrapper {
      display: none;
    }
    .el-radio__label {
      display: none;
    }
  }
}
</style>

<template>
  <div style="display: inline-block;">
    <div class="lib" @click="show">
      <slot></slot>
    </div>
    <el-dialog
      title="选择视频"
      :visible.sync="dialog"
      width="1000px"
      top="10vh"
      class="soundLib"
      :append-to-body="true"
      @close="close"
    >
      <el-table :data="list" class="list">
        <el-table-column width="50" align="center">
          <template slot-scope="scope">
            <el-radio v-model="active" :label="scope.row"></el-radio>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">{{scope.row.content.title}}</template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">{{momentutc(scope.row.createdDate)}}</template>
        </el-table-column>
        <el-table-column width="100">
          <template slot-scope="scope">
            <i class="iconfont el-icon-video-play" @click="play(scope.row.content.videoUrl)"></i>
          </template>
        </el-table-column>
      </el-table>
      <div class="alignc">
        <el-pagination
          :current-page.sync="page"
          :page-size="size"
          layout="total, prev, pager, next, jumper"
          :total="totalSize"
          @current-change="getItem"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  data() {
    return {
      active: null,
      dialog: false,
      page: 1,
      size: 8,
      list: [],
      totalSize: 0,
      voice: '',
    };
  },
  methods: {
    close() {
      if (this.voice) {
        this.voice.stop();
        this.voice.destruct();
      }
    },
    play(url) {
      if (!url) {
        this.$message.warning('该视频暂未通过审核');
        return;
      }
      window.open(url);
    },
    show() {
      this.dialog = true;
      this.getItem();
    },
    async getItem() {
      let res = await this.$http(`/api/${this.id}/materials`, {
        params: {
          type: 5,
          page: this.page,
          size: this.size,
        },
      });
      console.log(JSON.stringify(res.list));
      this.totalSize = res.totalSize;
      this.list = res.list;
    },
    confirm() {
      let data = Object.assign({}, this.active);
      this.$emit('confirm', data);
      this.dialog = false;
    },
  },
  mounted() {},
};
</script>
